import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, ActionSheetController, Events } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { MobileAppService } from '../../services/mobile-app';
import { HomePage } from '../home/home';
import { ToastProvider } from '../../providers/toast/toast';
import { SendPasswordPage } from '../send-password/send-password';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@IonicPage()
@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html',
})
export class ForgotPasswordPage {
  data: any = {};

  username: string;
  otp: number;
  confirmedPassword: string;
  newPassword: string;
  
  token: string;
  hash: string;
  id: number;

  private otpSent = false;
  private otpVerified = false;

  isOtpValid = true;
  isPasswordValid = true;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private loginProvider: LoginProvider,
    public event: Events,
    private mobileApp: MobileAppService,
    private toast: ToastProvider,
    private util: UtilService) {
    this.data = {
      "background"      : "assets/images/background/26.jpg",
      "subtitle"        : "Welcome to Isociety",
      "title"           : "Forgot password",
      "logo"            : "assets/images/logo/ism"+environment.icon+".png",
      "errorUser"       : "Field can't be empty",
      "errorPassword"   : "Field can't be empty"
  };
  }

  sendOtp(){
    if(!this.username || this.username.length == 0){
      this.isOtpValid = false;
      return;
    }
    this.loginProvider.fpGenerateOtp(this.username).then(val => {
      if(val.status == "success"){
        this.hash = val.hash;
        this.id = val.id;
        this.otpSent = true;
      }else {
        this.toast.presentToast(val.message);
      }
    }).catch(e => {
      this.util.showNoInternet(true);
    });;
  }

  verifyOtp(){
    if(!this.otp){
      this.isOtpValid = false;
      return;
    }
    this.loginProvider.fpVerifyOtp(this.hash, this.id, this.otp).then(val => {
      if(val.status == "success"){
        this.token = val.token;
        this.id = val.id
        this.otpVerified = true;
      }else {
        this.toast.presentToast(val.message);
      }
    }).catch(e => {
      this.util.showNoInternet(true);
    });
  }

  resetPassword(){
    if((!this.newPassword || this.newPassword.length == 0) || 
      (!this.newPassword || this.newPassword.length == 0) ){
      this.isPasswordValid = false;
      return;
    }
    if(this.newPassword == this.confirmedPassword){
      this.loginProvider.resetPassword(this.id, this.token, this.confirmedPassword).then(val => {
        if(val.status == "success"){
          this.toast.presentToast("Password changed");
          this.navCtrl.push(HomePage);
        }else {
          this.toast.presentToast(val.message);
        }
      }).catch(e => {
        this.util.showNoInternet(true);
      });
    }else {
      this.toast.presentToast("New and confirm passwords are not same");
    }
  }

  onSendPass(){
    this.navCtrl.push(SendPasswordPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.ts